var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.products),function(product){return _c('li',{key:product.id},[_vm._v("\n        "+_vm._s(product.title)+"\n        "),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.addProductToCart(product)}}},[_vm._v("\n                Add to cart\n            ")])])}),0),_vm._v(" "),_c('Cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }